export default "__VITE_PUBLIC_ASSET__da3ca598__"